<script setup lang="ts">
import { signOut } from "aws-amplify/auth";
import { useRouter } from "vue-router";
import Toast from "./Toast.vue";

const router = useRouter();
const nav = [
  { to: "/producten", label: "Producten" },
  { to: "/categorieen", label: "Categorieën" },
  { to: "/bestellingen", label: "Bestellingen" },
  { to: "/voorraad", label: "Voorraad" },
  { to: "/klanten", label: "Klanten" },
  { to: "/checkouts", label: "Checkouts" },
  { to: "/instellingen", label: "Instellingen" },
];
async function logout() {
  await signOut();
  router.push("/login");
}
</script>

<template>
  <div class="layout">
    <aside class="sidebar">
      <RouterLink to="/producten" class="brand"><img src="/logo-binker.svg" alt="binker" /></RouterLink>
      <nav class="nav">
        <RouterLink v-for="n in nav" :key="n.to" :to="n.to" class="navitem" active-class="active">
          {{ n.label }}
        </RouterLink>
      </nav>
      <button class="logout" @click="logout">Uitloggen</button>
    </aside>
    <main class="content"><RouterView /></main>
    <Toast />
  </div>
</template>

<style scoped>
.layout { display: flex; min-height: 100vh; }
.sidebar {
  width: 232px; flex: 0 0 232px; background: var(--surface-off); border-right: 1px solid var(--hairline);
  padding: 20px 16px; display: flex; flex-direction: column; gap: 6px;
}
.brand { display: block; padding: 6px 10px 14px; }
.brand img { height: 30px; width: auto; display: block; }
.nav { display: flex; flex-direction: column; gap: 4px; }
.navitem { padding: 10px 12px; border-radius: 10px; text-decoration: none; color: var(--mid); font-weight: 600; font-size: 14px; }
.navitem:hover { background: var(--warm); color: var(--ink); }
.navitem.active { background: var(--coral); color: #fff; }
.logout { margin-top: auto; padding: 10px 12px; border: 0; background: none; color: var(--muted); font-size: 13px; text-align: left; cursor: pointer; }
.content { flex: 1; background: var(--surface); padding: 28px 32px; overflow: auto; }
</style>
